import React, { useEffect, useState } from 'react'
import { getGoodTypesAllAPI } from '../../../api/products/goodTypeAPI'
import MySelect from '../../UI/form/MySelect'
import { responseError } from '../../../helpers/response/ResponseHelper'
import { getGoodsAllAPI } from '../../../api/products/goodAPI'
import MySpiner from '../../UI/spiner/MySpiner'
import { getFactoriesAllAPI } from '../../../api/factory/factoryAPI'

const FactorySelectMain = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(forciblyValue)
	const [factories, setFactories] = useState([])

	const [loading, setLoading] = useState(false)

	useEffect(() => {
		getFactories()
	}, [])

	useEffect(() => {
		valid()
	}, [required, value])

	const getFactories = () => {
		setValueForm(null)
		setValue('')
		setLoading(true)
		getFactoriesAllAPI().then(data => {
			setFactories(data)
			setLoading(false)
		}).catch(e => {
			// setError(responseError(e))
			setLoading(false)
			console.error(responseError(e))
		})
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
			} else {
				setValidate(false)
			}
		} else {
			setValidate(true)
		}
	}

  return (
	<>
		{
			loading ?
				<MySpiner />
			:
				<MySelect
					value={value}
					label="Назва цеху"
					labelId="select__factory-label"
					id='select__factory'
					onChange = {e => {
						setValueForm(e)
						setValue(e)
						// setEvent({...event, categoryId: e})
					}}
					nameField='Назва цеху'
					// sx={{width: '200px'}}
					options={
						factories && factories.length > 0 ? 
							factories.map(factory => {
								return {id: factory.id, name: factory.name}
							})
						: []	
					}
					// options={[]}
				/>
		}
	</>
  )
}

export default FactorySelectMain